export default "__VITE_ASSET__DpnyX14C__"